import moment from "moment";
import {
  GET_LANGUAGE,
  SET_PAGE,
  SET_SEARCH,
  SET_COURSE_TYPE,
} from "../../shared/constants/ActionTypes";

const initialLanguage = {
  languages: [],
  languageCount: 0,
  page: 1,
  search: "",
};

const languageReducer = (state = initialLanguage, action) => {
  switch (action.type) {
    case GET_LANGUAGE:
      return {
        ...state,
        languages: action.payload.languages.map((language) => {
          return {
            ...language,

            updatedAtFormatted: moment(language.createdAt).format("ll"),
          };
        }),
        languageCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_COURSE_TYPE:
      return {
        ...state,
        courseType: action.payload,
      };

    default:
      return state;
  }
};

export default languageReducer;
